import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AppNotifyService } from 'src/app/core/services/app-notify.service';

@Component({
  selector: 'app-notify',
  templateUrl: './notify.component.html',
  styleUrls: ['./notify.component.scss'],
})
export class NotifyComponent implements OnInit {
  public message = 'notification alert.';

  constructor(private appNotifyService: AppNotifyService) {
    this.message = this.appNotifyService.notifyMessage;
  }
  @Output() public ignore: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {}

  public ignoreNotification(event: Event): void {
    event.preventDefault();
    this.ignore.emit();
  }
}
